/**
 * Enable POS inventory counts on PDP
 */
export const PDP_INVENTORY_COUNTS_240807 = 'PDP_INVENTORY_COUNTS_240807';
